import type { ForwardRefExoticComponent } from 'react';
import { forwardRef, useEffect } from 'react';
import useWindowSize from '@customHooks/useWindowSize';
import CatalogBtnDesktop from './Desktop';
import CatalogBtnMobile from './Mobile';
import { observer } from 'mobx-react';
import { autorun } from 'mobx';
import { useLocalStorage } from '@utils/usehooks/useLocalStorage';
import { consentModalKey } from '@store/ModalsStore';
import { useStores } from '@root/src/stores';

interface CatalogBtnI {
  isShow?: boolean;
  setIsShow?: (value: boolean) => void;
}
const CatalogBtn = observer(
  forwardRef<any, CatalogBtnI>(({ isShow, setIsShow }, ref) => {
    const { catalogStore, cartStore } = useStores();
    const { windowWidth } = useWindowSize();
    const [isConsentModalAgreed] = useLocalStorage(consentModalKey, 'false');

    useEffect(() => {
      // чтобы при изменении isDesktop шли разные запросы на меню. без этого изначально только прилетит меню взависимости от стартовой ширины экрана
      const disposer = autorun(() => {
        if (cartStore.isLoadCart && window.innerWidth) {
          // const currentShop = cartStore.shops.find(item => item.id === cartStore.cart?.store_id);
          // const isCurrentShopBar = currentShop?.type === 'oyster_bar';
          catalogStore.getCatalogMenu({
            is18plus:
              typeof isConsentModalAgreed === 'boolean'
                ? !!isConsentModalAgreed
                : isConsentModalAgreed === 'true',
            withBarMenu: !!cartStore.isCurrentAddressValidForExpress
          });
        }
      });
      return () => {
        disposer();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConsentModalAgreed]);

    if (!windowWidth || windowWidth === 0) {
      return null;
    }
    if (windowWidth >= 1280) {
      return (
        <CatalogBtnDesktop isShow={!!isShow} setIsShow={setIsShow} ref={ref} />
      );
    }
    return <CatalogBtnMobile />;
  })
);
CatalogBtn.displayName = 'CatalogBtn';
export default CatalogBtn as ForwardRefExoticComponent<
  CatalogBtnI & React.RefAttributes<any>
>;
